<template>
  <card-dashboard class="text-[#2d82b5] py-10">
    <div class="flex justify-between items-center px-4">
      <div>
        <p class="md-title font-bold text-xl md:text-3xl">
          {{ $t("dashboard.greeting.hello") }}
          {{ info.full_name }}
        </p>
        <div class="md-subhead text-base md:text-lg font-normal mt-2">
          <p>{{ $t("dashboard.greeting.sub_h1") }}</p>
          <p>{{ $t("dashboard.greeting.sub_h2") }}</p>
        </div>
      </div>
      <div class="hidden md:block">
        <img src="/img/dashboard/dashboard-student.png" alt="Dashboard image" />
      </div>
    </div>
  </card-dashboard>
</template>
<script>
import CardDashboard from "./CardDashboard";

export default {
  name: "greeting",
  components: { CardDashboard },
  props: ["info"]
};
</script>
